import { render } from "./emulatorDialComponent.vue?vue&type=template&id=320fffd8&scoped=true"
import script from "./emulatorDialComponent.vue?vue&type=script&lang=js"
export * from "./emulatorDialComponent.vue?vue&type=script&lang=js"

import "./emulatorDialComponent.vue?vue&type=style&index=0&id=320fffd8&lang=css&scoped=true"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320fffd8"]])

export default __exports__